import { Home, Experiences, Detail } from "./pages";
import { Global, css } from "@emotion/core";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Footer, ScrollToTop } from "./components/";

import { WithNav } from "./templates";

function App() {
  return (
    <div className="App">
      <Global
        styles={css`
          @import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap");
          @font-face {
            font-family: "Vacations In Paradise";
            src: url("/fonts/VacationsInParadise.ttf") format("truetype");
          }

          * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
          }

          html {
            font-size: 50%;
            font-family: "Roboto", sans-serif;
            color: #333;
          }

          #root {
            overflow: hidden;
          }

          a {
            text-decoration: none;
            color: #939da9;
            cursor: pointer;
            font-size: 2rem;
          }

          .rdrDateDisplayWrapper {
            display: none;
          }
        `}
      />
      <Router onUpdate={() => window.scrollTo(0, 0)}>
        <ScrollToTop />
        <Switch>
          <Route path="/experiences" render={() => WithNav(Experiences)} />
          <Route path="/detail/:id" render={() => WithNav(Detail)} />
          <Route path="/" component={Home} />
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
